import React from 'react'
import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI/colors.constant'

const FieldInfoNG = ({ label, children, rootStyle = {}, labelStyle = {}, style, isVertical = false, gap = 5 }) => {
  const useStyles = makeStyles(theme => ({
    root: {
      display: 'flex',
      flexDirection: isVertical ? 'column' : 'row',
      gap,
      ...rootStyle
    },
    label: {
      textAlign: 'left',
      color: GRAY_COLORS[500],
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '20px',
      ...labelStyle
    },
    style: style ? style : {}
  }))
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.label}>{label}</div>
      <div className={classes.style}>{children}</div>
    </div>
  )
}

export default FieldInfoNG
